import React from "react";
import Articles from "../components/Articles.jsx";
import Hero from "../components/Hero.jsx";
import FAQs from "../components/Fags.jsx";

export default function Home() {
  return (
    <div className="px-4 sm:px-8 gap-2">
    <Hero />
    <div className="my-5">
      <Articles />
    </div>
    <div className="my-5">
      {/* FAQ Section */}
      <div className="flex flex-col items-center gap-4 px-4 sm:px-12 md:px-16 lg:px-20 xl:px-32 my-5 w-full">
        <div className="bg-gray-300 p-1 w-full max-w-3xl rounded-lg"></div>
        <h1 className="text-2xl font-bold tracking-tight text-center sm:text-4xl lg:text-5xl">
          Questions Fréquemment Posées
        </h1>
        <div className="bg-gray-300 p-1 w-full max-w-3xl rounded-lg"></div>
      </div>
      <FAQs />
    </div>
  </div>
  
  
  );
}
